import React, {useState} from "react"

import {List, ListItemStock, Pagination} from "~/components/"

import {useApi} from "~/hooks/"
import {withUserFeedback} from "~/helpers/"
import {useTranslation} from "react-i18next"

export const DestinationStocksList = ({id, ...other}) => {
  const {t} = useTranslation()
  const [params, setParams] = useState({
    page: 0
  })
  const setPage = page => setParams({page})

  const data = useApi(`/destinations/${id}/stocks`, {
    params,
    headers: {
      Accept: "application/vnd.shelf.v2"
    }
  })
  const stocks = data && data.items
  const totalPages = data && data.total_pages

  return (
    <div className="sh-searchable-list">
      <div className="results">
        {withUserFeedback(
          () => (
            <React.Fragment>
              <List items={stocks} itemRenderer={ListItemStock} {...other}>
                <p>{t("destinations.detail.stocks.nothing")}</p>
              </List>
              <Pagination
                currentPage={params.page}
                totalPages={totalPages}
                onPageChange={setPage}
              />
            </React.Fragment>
          ),
          [data]
        )}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/list/DestinationStocksList.js